import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import PatientFileService from '@/services/PatientFileService';
import type { PatientFile } from '@/services/PatientFileService';
import { PATIENT_FILE_KEYS } from './keys';

// Imperative one-shot for load-on-userid-change flows where the consumer
// needs to coordinate the result with parallel fetches.
export function useFetchPatientFile() {
  const qc = useQueryClient();
  return useCallback(
    (userid: string | number) => qc.fetchQuery({
      queryKey: PATIENT_FILE_KEYS.byUser(userid),
      queryFn: () => PatientFileService.fetchPatientFile(userid),
    }),
    [qc],
  );
}

export type { PatientFile };
